export default "__VITE_ASSET__BKGW$iew__"